import { render, staticRenderFns } from "./OrkLightBox.html?vue&type=template&id=1ebb28b8&scoped=true&"
import script from "./OrkLightBox.vue?vue&type=script&lang=js&"
export * from "./OrkLightBox.vue?vue&type=script&lang=js&"
import style0 from "./OrkLightBox.scss?vue&type=style&index=0&id=1ebb28b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb28b8",
  null
  
)

export default component.exports